import { createStore } from "redux";
import rootReducer from "../../reducer";

function configureStore() {
  return createStore(rootReducer );
}

const store = configureStore();
export default store;